function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/** */
var TruncatedHit =
/*#__PURE__*/
function () {
  /** */
  function TruncatedHit(hit) {
    var maxChars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
    var minimum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

    _classCallCheck(this, TruncatedHit);

    this.hit = hit;
    this.maxChars = maxChars;
    this.minimum = minimum;
  }
  /** */


  _createClass(TruncatedHit, [{
    key: "charsOnSide",
    get: function get() {
      var resultingChars = (this.maxChars - this.hit.match.length) / 2;
      var measured = [(this.hit.before || '').length, (this.hit.after || '').length].filter(function (length) {
        return length > 0;
      });
      return Math.max(Math.min.apply(Math, [resultingChars].concat(_toConsumableArray(measured))), this.minimum);
    }
    /** */

  }, {
    key: "before",
    get: function get() {
      if (!this.hit.before) return '';
      return this.hit.before.substring(this.hit.before.length - this.charsOnSide, this.hit.before.length);
    }
    /** */

  }, {
    key: "match",
    get: function get() {
      return this.hit.match;
    }
    /** */

  }, {
    key: "after",
    get: function get() {
      if (!this.hit.after) return '';
      return this.hit.after.substring(0, Math.min(this.hit.after.length, this.charsOnSide));
    }
  }]);

  return TruncatedHit;
}();

export { TruncatedHit as default };